export const CREATE_MESSAGE = `
mutation($message: String, $user: ID, $channelId: ID) {
    createMessage(
      input: { data: { message: $message, user: $user, channelId: $channelId } }
    ) {
      message {
        id
      }
    }
  }
`;

export const RESET_UNREAD_COUNT = `
mutation($profileId: ID!) {
  resetUnreadCount(profileId: $profileId) {
    count
  }
}
`;
